import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import RichText from "./RichText";

const TAG_LINKS_MUSIC = {
  "Audio Branding": "/music/audio-branding",
  "Series, Cine y TV": "/music/series-cine-tv",
  "Producción Artística": "/music/produccion-artistica",
};

const TAG_LINK_TEAMS = "/teams";

function TagPill({ label, to }) {
  const cls =
    "px-4 py-1.5 rounded-full border border-white/25 text-[12px] md:text-[13px] font-medium bg-white/5 backdrop-blur-sm hover:bg-white/15 hover:border-white/50 transition-colors";
  if (to) return <Link to={to} className={cls}>{label}</Link>;
  return <span className={cls}>{label}</span>;
}

export default function HeroSplit({ hero }) {
  const { music, teams } = hero;
  return (
    <section className="relative w-full min-h-screen flex flex-col md:flex-row">
      {/* MUSIC PANEL */}
      <div id="music" className="group relative w-full md:w-1/2 min-h-[85vh] md:min-h-screen overflow-hidden">
        <img src={music.image} alt="Kilombo Music" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
        <div className="absolute inset-0 hero-overlay-music" />
        <div className="absolute inset-0 noise-overlay pointer-events-none" />

        <div className="relative z-10 flex flex-col justify-center h-full px-6 md:px-10 lg:px-16 pt-28 md:pt-40 pb-16 md:pb-24">
          <h1 className="font-display font-black text-[40px] leading-[1.02] sm:text-5xl md:text-5xl lg:text-6xl xl:text-7xl text-white drop-shadow-[0_6px_30px_rgba(0,0,0,0.4)]">
            {music.title_line1}<br />{music.title_line2}
          </h1>
          <p className="mt-6 max-w-md text-white/95 text-[15px] md:text-base leading-relaxed">
            <RichText text={music.description} />
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            {(music.tags || []).map((t) => (
              <TagPill key={t} label={t} to={TAG_LINKS_MUSIC[t]} />
            ))}
          </div>
          <div className="mt-8 md:mt-10">
            <Link to={music.cta_link || "/music"} className="btn-shine inline-flex items-center gap-3 rounded-full bg-black text-white pl-5 md:pl-6 pr-4 md:pr-5 py-3 md:py-3.5 font-mono-caps text-xs tracking-[0.2em] uppercase border border-black hover:bg-neutral-900 transition-colors">
              {music.cta_label}
              <span className="w-7 h-7 rounded-full bg-white text-black flex items-center justify-center">
                <ArrowRight className="w-3.5 h-3.5" />
              </span>
            </Link>
          </div>
        </div>
      </div>

      {/* TEAMS PANEL */}
      <div id="teams" className="group relative w-full md:w-1/2 min-h-[85vh] md:min-h-screen overflow-hidden">
        <img src={teams.image} alt="Kilombo Teams" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
        <div className="absolute inset-0 hero-overlay-teams" />
        <div className="absolute inset-0 noise-overlay pointer-events-none" />

        <div className="relative z-10 flex flex-col justify-center h-full px-6 md:px-10 lg:px-16 pt-28 md:pt-40 pb-16 md:pb-24 md:items-end md:text-right">
          <h1 className="font-display font-black text-[40px] leading-[1.02] sm:text-5xl md:text-5xl lg:text-6xl xl:text-7xl text-white drop-shadow-[0_6px_30px_rgba(0,0,0,0.4)]">
            {teams.title_line1}<br />{teams.title_line2}
          </h1>
          <p className="mt-6 max-w-md text-white/95 text-[15px] md:text-base leading-relaxed md:text-right">
            <RichText text={teams.description} />
          </p>
          <div className="mt-6 flex flex-wrap gap-2 md:justify-end">
            {(teams.tags || []).map((t) => (
              <TagPill key={t} label={t} to={TAG_LINK_TEAMS} />
            ))}
          </div>
          <div className="mt-8 md:mt-10">
            <Link to={teams.cta_link || "/teams"} className="btn-shine inline-flex items-center gap-3 rounded-full bg-white text-black pl-5 md:pl-6 pr-4 md:pr-5 py-3 md:py-3.5 font-mono-caps text-xs tracking-[0.2em] uppercase hover:bg-neutral-100 transition-colors">
              {teams.cta_label}
              <span className="w-7 h-7 rounded-full bg-black text-white flex items-center justify-center">
                <ArrowRight className="w-3.5 h-3.5" />
              </span>
            </Link>
          </div>
        </div>
      </div>

      {/* Center K badge */}
      <div className="hidden md:flex absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-20 items-center justify-center">
        <div className="relative w-16 h-16 rounded-full bg-black border border-white/20 flex items-center justify-center shadow-2xl">
          <div className="absolute inset-0 rounded-full bg-gradient-to-br from-[#ff8a3c]/40 via-transparent to-[#2ec9a8]/40 blur-md -z-10" />
          <span className="font-display text-2xl text-white">K</span>
        </div>
      </div>
    </section>
  );
}
